import EmployeeServices from '../../services/housing_units/employee';

export const state = {
    employees: [],
    employee: {},
}

export const mutations = {
    setEmployee(state, employee) {
        state.employee = employee
    },
    setEmployees(state, employees) {
        state.employees = employees
    }
}

export const getters = {
    getEmployee(state) {
        return state.employee;
    },
    getEmployees(state) {
        return state.employees;
    },
}

export const actions = {
    get({commit}, id){
        return EmployeeServices.get(id)
        .then((response)=>{
            commit('setEmployee', response.data.data)
            return response
        })
    },
    getAll({commit}, data = {}){
        return EmployeeServices.getAll(data)
        .then((response)=>{
            commit('setEmployees', response.data.data)
            return response
        })
    },
    delete({state, commit}, id){
        return EmployeeServices.delete(id)
        .then((response)=>{
            commit('setEmployees', state.employees.filter((x)=>x.id != id))
            return response
        })
    },
}